module.exports = __webpack_public_path__ + "static/media/undo.e3aa9e90.svg";